import request from "../../request.js"
import qs from "qs";
// 新增抽奖活动
export  function addPzMain(data) {
	return request({
		url: "/pz-main/addPzMain",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除抽奖活动
export  function deletePzMain(data) {
	return request({
		url: "/pz-main/deletePzMain",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 列表抽奖活动
export  function getPzMainList(data) {
	return request({
		url: "/pz-main/getPzMainList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑抽奖活动
export  function updatePzMain(data) {
	return request({
		url: "/pz-main/updatePzMain",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 新增抽奖活动奖品
export  function addPzItem(data) {
	return request({
		url: "/pz-item/addPzItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除抽奖活动奖品
export  function deletePzItem(data) {
	return request({
		url: "/pz-item/deletePzItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 抽奖活动奖品详情
export  function getPzItemDetails(data) {
	return request({
		url: "/pz-item/getPzItemDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 抽奖活动奖品列表
export  function getPzItemList(data) {
	return request({
		url: "/pz-item/getPzItemList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 抽奖
export  function getPzItemPrize(data) {
	return request({
		url: "/pz-item/getPzItemPrize",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 抽奖活动奖品编辑
export  function updatePzItem(data) {
	return request({
		url: "/pz-item/updatePzItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 上传文件
export  function uploadFileLocal(data) {
	return request({
		url: "/pz-other/uploadFileLocal",
		method: "POST",
		data
	})
}
// 抽奖活动用户新增
export  function addPzMainUser(data) {
	return request({
		url: "/pz-main-user/addPzMainUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 抽奖活动用户删除
export  function deletePzMainUser(data) {
	return request({
		url: "/pz-main-user/deletePzMainUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 抽奖活动用户列表
export  function getPzMainUserList(data) {
	return request({
		url: "/pz-main-user/getPzMainUserList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 抽奖活动用户编辑
export  function updatePzMainUser(data) {
	return request({
		url: "/pz-main-user/updatePzMainUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 中奖记录
export  function getPzItemRecordList(data) {
	return request({
		url: "/pz-item-record/getPzItemRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 参与抽奖用户列表
export  function getPzItemPrizeUserList(data) {
	return request({
		url: "/pz-item/getPzItemPrizeUserList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增投票活动
export  function addPzVoteMain(data) {
	return request({
		url: "/pz-vote-main/addPzVoteMain",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除投票活动
export  function deletePzVoteMain(data) {
	return request({
		url: "/pz-vote-main/deletePzVoteMain",
		method: "POST",
		data:qs.stringify(data)
	})
}
//列表投票活动
export  function getPzVoteMainList(data) {
	return request({
		url: "/pz-vote-main/getPzVoteMainList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑投票活动
export  function updatePzVoteMain(data) {
	return request({
		url: "/pz-vote-main/updatePzVoteMain",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增投票项
export  function addPzVoteItem(data) {
	return request({
		url: "/pz-vote-item/addPzVoteItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除投票项
export  function deletePzVoteItem(data) {
	return request({
		url: "/pz-vote-item/deletePzVoteItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
//列表投票项
export  function getPzVoteItemList(data) {
	return request({
		url: "/pz-vote-item/getPzVoteItemList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑投票项
export  function updatePzVoteItem(data) {
	return request({
		url: "/pz-vote-item/updatePzVoteItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
//验证用户
export  function getPzMainUserLogin(data) {
	return request({
		url: "/pz-vote-user/getPzMainUserLogin",
		method: "POST",
		data:qs.stringify(data)
	})
}
//验证用户
export  function addPzVoteRecord(data) {
	return request({
		url: "/pz-vote-user/addPzVoteRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//投票排行榜
export  function getPzVoteRecordRankUser(data) {
	return request({
		url: "/pz-vote-user/getPzVoteRecordRankUser",
		method: "POST",
		data:qs.stringify(data)
	})
}